<template>
<div></div>
</template>
<script>
export default {
  name: 'refresh',
  created () {
    this.$router.replace(this.$route.query.path)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/refresh.vue